import React, { Component } from 'react';
import {AppBar, Toolbar } from '@material-ui/core';
import Link from 'react-router-dom/Link';

import '../components/Navbar.css';
import animojiMac from '../images/animojiMac.png';

export class Navbar extends Component {


    constructor(props) {
        super(props)
    
        this.state = {
          hasScrolled: false
        }
      }

      componentDidMount() {
        window.addEventListener('scroll', this.handleScroll)
      }
    
      handleScroll = (event) => {
        const scrollTop = window.pageYOffset
    
        if (scrollTop > 50) {
          this.setState({ hasScrolled: true })
        } else {
          this.setState({ hasScrolled: false })
        }
      }

    render() {
        return (
          <AppBar color="transparent" position="fixed">
            <Toolbar>
              <div className={this.state.hasScrolled? 'Header HeaderScrolled' : 'Header'}>
                <div className= "HeaderGroup">
                  <div className="HeaderImage">
                    <Link to="personal"><img src={animojiMac} alt=""/></Link>
                  </div>
                  <Link to="/"><h3 className="HeaderWord" component>Home</h3></Link>
                  <Link to="/skills"><h3 className="HeaderWord">Skills</h3></Link>
                  <Link to="work"><h3 className="HeaderWord">My Work</h3></Link>
                  <Link to="contact"><button>Contact</button></Link>
                </div>
              </div>
            </Toolbar>
          </AppBar>
        )
    }
}

export default Navbar
